import {
  CommunicationItemType,
  CommunicationDirection,
  CommunicationStatus,
  ICommunicationHistory,
} from '@dataTypes/communicationHistory.type'

const DEMO_PATIENT_NAME = 'John Doe'

/** Shared ids aligned with Message Center demo fixtures (see emailMock.ts). */
export const DEMO_COMMUNICATION_MESSAGE_IDS = {
  email: {
    appointmentConfirmation: 'patient-comm-email-1',
    insuranceFwd: 'patient-comm-email-2',
    appointmentReminder: 'patient-comm-email-3',
    documentRequest: 'patient-comm-email-4',
  },
  sms: {
    rescheduleRequest: 'patient-comm-sms-5',
    appointmentReminder: 'patient-comm-sms-8',
    conversationId: 'patient-comm-sms-conversation',
  },
  fax: {
    outboundDocuments: 'patient-comm-fax-6',
    inboundDocuments: 'patient-comm-fax-7',
  },
  calls: {
    inquiry: 'patient-comm-call-9',
    missed: 'patient-comm-call-10',
  },
} as const

export const DEMO_COMMUNICATIONS_HISTORY: ICommunicationHistory[] = [
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.email.appointmentConfirmation,
    type: CommunicationItemType.Email,
    direction: CommunicationDirection.Outbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Appointment Confirmation for 3:30 PM Feb 22',
    timestamp: '2024-02-28T09:20:00.000Z',
    status: CommunicationStatus.Received,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.email.insuranceFwd,
    type: CommunicationItemType.Email,
    direction: CommunicationDirection.Outbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Fwd: Insurance Information Update Request',
    timestamp: '2024-02-28T09:21:00.000Z',
    status: CommunicationStatus.Received,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.email.appointmentReminder,
    type: CommunicationItemType.Email,
    direction: CommunicationDirection.Inbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Appointment Reminder',
    timestamp: '2024-02-28T09:00:00.000Z',
    status: CommunicationStatus.Sent,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.email.documentRequest,
    type: CommunicationItemType.Email,
    direction: CommunicationDirection.Inbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Fwd: Patient Document Request Confirmation',
    timestamp: '2024-02-28T09:05:00.000Z',
    status: CommunicationStatus.Sent,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.sms.rescheduleRequest,
    type: CommunicationItemType.SMS,
    direction: CommunicationDirection.Outbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Hi, would it be okay if I move my appointment for a couple of day',
    timestamp: '2024-02-15T08:05:00.000Z',
    status: CommunicationStatus.Read,
    conversationId: DEMO_COMMUNICATION_MESSAGE_IDS.sms.conversationId,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.fax.outboundDocuments,
    type: CommunicationItemType.Fax,
    direction: CommunicationDirection.Outbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Medical Documents from Denta Clean Clinic',
    timestamp: '2024-02-07T17:05:00.000Z',
    status: CommunicationStatus.Received,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.fax.inboundDocuments,
    type: CommunicationItemType.Fax,
    direction: CommunicationDirection.Inbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Documents from previous appointments',
    timestamp: '2024-02-06T10:00:00.000Z',
    status: CommunicationStatus.Received,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.sms.appointmentReminder,
    type: CommunicationItemType.SMS,
    direction: CommunicationDirection.Inbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Hi, John! We would like to remind you of the unscheduled appoi',
    timestamp: '2024-02-01T08:10:00.000Z',
    status: CommunicationStatus.Delivered,
    conversationId: DEMO_COMMUNICATION_MESSAGE_IDS.sms.conversationId,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.calls.inquiry,
    type: CommunicationItemType.Calls,
    direction: CommunicationDirection.Inbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Inquiry',
    timestamp: '2024-01-15T11:10:00.000Z',
    status: CommunicationStatus.Connected,
  },
  {
    id: DEMO_COMMUNICATION_MESSAGE_IDS.calls.missed,
    type: CommunicationItemType.Calls,
    direction: CommunicationDirection.Inbound,
    patientName: DEMO_PATIENT_NAME,
    text: 'Unknown',
    timestamp: '2024-01-15T10:15:00.000Z',
    status: CommunicationStatus.Missed,
  },
]
